<template>
   <el-popover
	 		placement="top-end" 
			title="Disbursement Items" 
			trigger="click"
			@show="getListing()"
			>
			<div v-if="!onload">
				<div v-if="!_gHlp.isEmpty(listData)">
					<el-table :data="listData" size="mini">
						<el-table-column width="300" property="description" label="Description">
							<template slot-scope="scope">
								<p class="top-line">{{ scope.row.description }}</p>
								<p class="bottom-line">{{ scope.row.disburse_date | dateFormatString }}</p>
							</template>
						</el-table-column>
						<el-table-column width="150" property="amount" label="Amount">
							<template slot-scope="scope">
								<p class="top-line">{{ scope.row.amount | moneyFormatter }}</p>
							</template>
						</el-table-column>
						<el-table-column width="100" property="status" label="Status">
							<template slot-scope="scope">
								<p class="top-line">{{ scope.row.status }}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-else>
					<small><i>No Record</i></small>
				</div>
			</div>
			<div v-else>
				<small><i>load content...</i></small>
			</div>
			<div slot="reference" class="btn btn-icon btn-sm btn-primary rounded-circle cursor-pointer">{{ total_disbursement }}</div>
	</el-popover>
	
</template>
<script>
	import { Popover, Table, TableColumn } from 'element-ui'
	import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
	import { mapActions } from 'pinia'
	import { useLoanCaseStore } from '@/stores/loanCaseStore';
	
  export default {
		props: ['case_id','total_disbursement'],
    name: 'attachment-list-popover',
		components:{
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Popover.name]: Popover
		},
    data() {
      return {
        listData: [],
				onload: false
      }
    },
		methods: {
				...mapActions(useLoanCaseStore, ['getDisbList']),
				async getListing(){
					this.onload = true;
					this.getDisbList(this.case_id).then(resp => {
						this.listData = resp.data;
						this.onload = false;
					}).catch(e => {
						_gNotif.errorFunction(e);
						this.onload = false;
					});
				}
		}

  }
</script>
